import * as $ from 'jquery';

export class CourseSummary {
    constructor() {
        $(".coursesummary .title .expand").on("click", function () {
            const $this = $(this);
            const $chapter = $this.closest(".chapter");
            const $lessons = $(".lessons", $chapter);
            if ($lessons.is(':visible')) {
                $this.text('Show Lesson');
                $lessons.slideUp();
            }
            else {
                $this.text('Hide Lesson');
                $lessons.slideDown();
            }
        });
    }
}